module.exports = __webpack_public_path__ + "img/ecology2.09c924a4.jpeg";